import { combineReducers } from 'redux';
import { StoreState } from '../createStore';
import auth from './auth/reducer';
import theme from './theme/reducer';

export default combineReducers<StoreState>({
  auth,
  theme,
});
